// src/components/InsightsView.js
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import InsightsEngine from './InsightsEngine'; // Assuming correct path
import { formatDate, formatDateTime } from '../utils';

const InsightsView = () => {
    // Get neo4jService and clientId from the parent route context
    const { neo4jService, clientId } = useOutletContext();

    return (
        <>
            <h2 className="text-xl font-semibold mb-6">AI-Generated Insights</h2>
            {/* Pass the necessary props to the InsightsEngine */}
            {neo4jService && clientId ? (
                <InsightsEngine clientId={clientId} neo4jService={neo4jService} />
            ) : (
                <p className="text-center py-10">Loading insights engine...</p> // Placeholder if context isn't ready
            )}
        </>
    );
};

export default InsightsView;